/* Ver. 2026/04/03 */
/**
 * AT トップページ アニメーション統合スクリプト
 * 初回表示（body.appear・フォールバック）、スクロール連動、ナビ等
 * jQuery非依存・外部CDN非依存
 */
(function() {
  'use strict';

  var announcementBarLastScroll = 0;

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  /* ---- レスポンシブ: ハンバーガーメニュー（960px以下） ---- */
  function mediaQueriesWin() {
    var width = window.innerWidth || document.documentElement.clientWidth;
    var hasChildLinks = document.querySelectorAll('.has-child > a');
    if (width <= 960) {
      /* モバイル: サブメニューを初期状態で閉じる */
      document.querySelectorAll('.has-child').forEach(function(li) {
        li.classList.remove('active');
        var ul = li.querySelector('ul');
        if (ul) ul.style.display = 'none';
      });
      hasChildLinks.forEach(function(link) {
        link.onclick = function(e) {
          var parent = link.parentElement;
          parent.classList.toggle('active');
          var ul = parent.querySelector('ul');
          if (ul) {
            /* CSSでdisplay:noneが指定されているため、表示時は明示的にblockを指定する必要がある */
            ul.style.display = ul.style.display === 'none' ? 'block' : 'none';
          }
          e.preventDefault();
          return false;
        };
      });
    } else {
      hasChildLinks.forEach(function(link) {
        link.onclick = null;
      });
      document.querySelectorAll('.has-child').forEach(function(li) {
        li.classList.remove('active');
        var ul = li.querySelector('ul');
        if (ul) ul.style.display = '';
      });
    }
  }

  /* ---- お知らせ欄: スクロールで隠す/表示 ---- */
  function announcementBarAnime() {
    var bars = document.querySelectorAll('.at-announcement-bar');
    if (!bars.length) return;
    var scroll = getScrollTop();
    bars.forEach(function(bar) {
      if (scroll <= 20) {
        bar.classList.remove('at-announcement-bar--hidden');
      } else if (scroll > announcementBarLastScroll) {
        bar.classList.add('at-announcement-bar--hidden');
      } else {
        bar.classList.remove('at-announcement-bar--hidden');
      }
    });
    announcementBarLastScroll = scroll;
  }

  /* ---- ハンバーガーメニュー開閉 ---- */
  var openBtn = document.querySelector('.g-nav-openbtn');
  var gNav = document.getElementById('g-nav');
  if (openBtn && gNav) {
    openBtn.addEventListener('click', function() {
      openBtn.classList.toggle('active');
      gNav.classList.toggle('panelactive');
    });
    gNav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function(e) {
        /* has-childの親リンク（Collection等）はサブメニュー開閉のみで、メニューは閉じない */
        var parentLi = a.closest('li.has-child');
        if (parentLi && a.parentElement === parentLi) {
          return;
        }
        openBtn.classList.remove('active');
        gNav.classList.remove('panelactive');
      });
    });
  }

  /* ---- ページトップボタン表示制御 ---- */
  function setFadeElement() {
    var pageTop = document.getElementById('page-top');
    var contact = document.getElementById('contact');
    var footer = document.getElementById('footer');
    if (!pageTop) return;
    var scrollTop = getScrollTop();
    var windowH = window.innerHeight;

    var contactInView = contact && (contact.getBoundingClientRect().top <= windowH && contact.getBoundingClientRect().bottom >= 0);
    var footerInView = footer && (footer.getBoundingClientRect().top <= windowH && footer.getBoundingClientRect().bottom >= 0);

    if (contactInView || footerInView) {
      pageTop.classList.add('LeftMove');
      pageTop.classList.remove('RightMove');
    } else {
      pageTop.classList.add('RightMove');
      pageTop.classList.remove('LeftMove');
    }
  }

  /* ---- ページトップボタン クリック ---- */
  var pageTop = document.getElementById('page-top');
  if (pageTop) {
    pageTop.addEventListener('click', function(e) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      e.preventDefault();
      return false;
    });
  }

  /* ---- 検索パネル開閉 ---- */
  var openSearchBtn = document.querySelector('.open-btn');
  var closeSearchBtn = document.querySelector('.close-btn');
  var searchWrap = document.getElementById('search-wrap');
  var searchText = document.getElementById('search-text');
  if (openSearchBtn && searchWrap) {
    openSearchBtn.addEventListener('click', function() {
      searchWrap.classList.add('panelactive');
      if (searchText) searchText.focus();
    });
  }
  if (closeSearchBtn && searchWrap) {
    closeSearchBtn.addEventListener('click', function() {
      searchWrap.classList.remove('panelactive');
    });
  }

  /* ---- スクロール連動アニメーション（bgappear / bgLRextend / bgRLextend） ---- */
  function fadeAnime() {
    var windowH = window.innerHeight;
    var triggerOffset = 50;

    document.querySelectorAll('.bgappearTrigger').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top <= windowH + triggerOffset) {
        el.classList.add('bgappear');
      } else {
        el.classList.remove('bgappear');
      }
    });

    document.querySelectorAll('.bgLRextendTrigger').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top <= windowH + triggerOffset) {
        el.classList.add('bgLRextend');
      } else {
        el.classList.remove('bgLRextend');
      }
    });

    document.querySelectorAll('.bgRLextendTrigger').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top <= windowH + triggerOffset) {
        el.classList.add('bgRLextend');
      } else {
        el.classList.remove('bgRLextend');
      }
    });

    document.querySelectorAll('.service-area').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top <= windowH + triggerOffset) {
        el.classList.add('startwd');
      } else {
        el.classList.remove('startwd');
      }
    });
  }

  /* ---- スクロール・リサイズイベント ---- */
  function onScroll() {
    announcementBarAnime();
    setFadeElement();
    fadeAnime();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', mediaQueriesWin);

  /* ---- ハッシュスクロール（初回表示時） ---- */
  function getHashID(hash) {
    if (!hash || hash === '#' || hash.length < 2) return;
    try {
      var el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      /* 無効なセレクタは無視 */
    }
  }

  /* ---- トップ（index）: スプラッシュなしで本文表示。load 未発火時もタイムアウトで表示 ---- */
  if (!document.body.classList.contains('page-about')) {
    var indexPageRevealed = false;
    var indexRevealFallbackMs = 5000;
    var indexRevealFallbackTimer;

    function revealIndexPage() {
      if (indexPageRevealed) return;
      indexPageRevealed = true;
      clearTimeout(indexRevealFallbackTimer);

      document.body.classList.add('appear');
      mediaQueriesWin();
      announcementBarAnime();
      setFadeElement();
      getHashID(location.hash);
      fadeAnime();
    }

    indexRevealFallbackTimer = setTimeout(revealIndexPage, indexRevealFallbackMs);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealIndexPage);
    } else {
      revealIndexPage();
    }
    window.addEventListener('load', revealIndexPage);
  }
})();
